import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import ChatIcon from '@material-ui/icons/Chat';

import useSession from 'core/hooks/use-session';
import { openFrontChatPopup } from 'core/components/front-chat';

const useStyles = makeStyles((theme) => ({
  floatingContainer: {
    position: 'fixed',
    bottom: '125px',
    right: '35px',
    zIndex: 100
  }
}));

const StaffSpeedDial = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const session = useSession();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleBugReport = () => {
    window.open('https://ourbranch.typeform.com/to/QsfFE7NK', '_blank');
  };

  const chatLabel = session.isInternalAgent ? 'Internal Help Desk' : 'Agency Support Chat';

  return (
    <div className={classes.floatingContainer}>
      <SpeedDial
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        icon={<HelpOutlineOutlinedIcon />}
        ariaLabel="Staff Speed Dial"
      >
        <SpeedDialAction
          key="Need Assistance?"
          icon={<ContactSupportOutlinedIcon />}
          tooltipTitle="Need Assistance?"
          onClick={handleBugReport}
        />
        <SpeedDialAction key={chatLabel} icon={<ChatIcon />} tooltipTitle={chatLabel} onClick={openFrontChatPopup} />
      </SpeedDial>
    </div>
  );
};

export default StaffSpeedDial;
